'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
function PolicyLinks() {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <li className="footer-item relative inline-block px-3 py-0 pl-0 font-bold text-colorFg18 text-xs leading-[15px] "><Link prefetch={false} href="/policy/privacy">{"\uAC1C\uC778\uC815\uBCF4\uCC98\uB9AC\uBC29\uCE68"}</Link></li>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <li className="footer-item relative inline-block p-[0px_12px_0px_7px] text-[13px] leading-[15px]"><Link prefetch={false} href="/policy/service">{"\uC774\uC6A9\uC57D\uAD00"}</Link></li>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <li className="footer-item relative inline-block p-[0px_12px_0px_7px] text-[13px] leading-[15px]"><Link prefetch={false} href="/policy/youth">{"\uCCAD\uC18C\uB144\uBCF4\uD638\uC815\uCC45"}</Link></li>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <li className="footer-item relative inline-block p-[0px_12px_0px_7px] text-[13px] leading-[15px]"><Link prefetch={false} href="/policy/cast">{"\uBC29\uC1A1\uAE30\uC900\uC548\uB0B4"}</Link></li>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <li className="footer-item relative inline-block p-[0px_12px_0px_7px] text-[13px] leading-[15px]"><Link prefetch={false} href="/policy/play">{"\uC2DC\uCCAD\uAE30\uC900\uC548\uB0B4"}</Link></li>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <li className="footer-item relative inline-block p-[0px_12px_0px_7px] text-[13px] leading-[15px]"><Link prefetch={false} href="/policy/rights/intro">{"\uAD8C\uB9AC\uCE68\uD574\uC2E0\uACE0\uC13C\uD130"}</Link></li>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <li className="footer-item relative inline-block p-[0px_12px_0px_7px] text-[13px] leading-[15px]"><Link prefetch={false} href="/law" target="_blank" rel="noopener noreferrer">{"\uBC95\uB960\uC9C0\uC6D0\uC11C\uBE44\uC2A4"}</Link></li>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <li className="footer-item relative inline-block p-[0px_12px_0px_7px] text-[13px] leading-[15px]"><a target="_blank" rel="noopener noreferrer" href="https://events.pandalive.co.kr/2024/7/ad_partner">광고·제휴문의</a></li>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <li className="footer-item relative inline-block p-[0px_12px_0px_7px] text-[13px] leading-[15px]"><a target="_blank" rel="noopener noreferrer" href="https://www.doublemedia.co.kr/">회사소개</a></li>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <li className="relative inline-block p-[0px_12px_0px_7px] text-[13px] leading-[15px]"><a target="_blank" rel="noopener noreferrer" href="https://career.doublemedia.co.kr/">인재채용</a></li>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ul className="flex justify-center pt-[18px] text-[#777]">{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}<li className="sr-only relative inline-block p-[0px_12px_0px_7px] text-[13px] leading-[15px]"><Link prefetch={false} href="/site-map">사이트맵</Link></li></ul>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  return t10;
}
export default PolicyLinks;